<template>
  <v-container>
    <vpn-profiles></vpn-profiles>
    <application-rules></application-rules>
    <status-message></status-message>
  </v-container>
</template>
<script>
import StatusMessage from "@/components/status-message";
import ApplicationRules from "./components/application-rules/application-rules.vue";
import VpnProfiles from "./components/vpn-profiles/vpn-profiles.vue";
export default {
  name: "DataPathPage",
  components: {
    StatusMessage,
    ApplicationRules,
    VpnProfiles
  },
  created() {
    this.$store.commit("snackbar/toggleMessage", false);
  }
};
</script>
